module.exports = __webpack_public_path__ + "cb8abe2a1c6293ddcaaeff035b33f872.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-vivi.png
// module id = 594
// module chunks = 30